module.exports = __webpack_public_path__ + "static/img/logo-colored.e412fca.png";


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/assets/logo-colored.png
// module id = U/vA
// module chunks = 0